import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-input-copy-pix',
  templateUrl: './input-copy-pix.component.html',
  styleUrls: ['./input-copy-pix.component.css', '../../../../assets/styles/global/_modal.scss']
})
export class InputCopyPixComponent implements OnInit{
  @Input() valueKey: string | undefined = '';
  @Input() dateTimeTransation: string = '';
  counterFinalizado = false;
  openModalPix = false;

  constructor(private cdr: ChangeDetectorRef, private notify: NotificationService){}

  ngOnInit(): void {
  }

  finalizationCounter(event: any){
    this.counterFinalizado = event
    this.cdr.detectChanges();
  }

  copyPix(text: string | undefined) {
    if(!text) return;
    const inputElement = document.createElement('input');
    inputElement.value = text;
    document.body.appendChild(inputElement);
    inputElement.select();
    document.execCommand('copy');
    document.body.removeChild(inputElement);
    this.notify.success('Código copiado com sucesso!');
  }

  openQrCodeModal() {
    this.openModalPix = true;
  }

  closeQrCodeModal() {
    this.openModalPix = false;
  }
}
